import { render, staticRenderFns } from "./CouponList.vue?vue&type=template&id=25cb1652&scoped=true&"
import script from "./CouponList.vue?vue&type=script&lang=js&"
export * from "./CouponList.vue?vue&type=script&lang=js&"
import style0 from "./CouponList.vue?vue&type=style&index=0&id=25cb1652&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25cb1652",
  null
  
)

export default component.exports